import React from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import {
  Container,
  Typography,
  Button,
  Box,
} from '@mui/material';
import { Link } from 'react-router-dom';

function PublicationSchedule() {
  return (
    <div style={{ backgroundColor: '#f5f5f5', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <NavigationBar />
      <Container maxWidth="lg" style={{ padding: '30px 0', flex: 1 }}>
        <Typography variant="h4" gutterBottom style={{ color: '#388E3C', marginBottom: '25px' }}>
          Programme de Diffusion
        </Typography>

        <Typography variant="body1" paragraph style={{ marginBottom: '30px', fontSize: '1.1rem' }}>
          Découvrez le calendrier de diffusion des publications statistiques de l'INSBU.
        </Typography>

        <Box sx={{ display: 'flex', gap: 2, marginBottom: '40px', flexWrap: 'wrap' }}>
          <Button 
            variant="contained" 
            sx={{ 
              backgroundColor: '#4CAF50', 
              color: '#fff',
              '&:hover': { backgroundColor: '#388E3C' },
              padding: '10px 20px',
              fontSize: '1rem'
            }} 
            component={Link} 
            to="/publications-mensuelles"
          >
            Publications Mensuelles
          </Button>
          <Button 
            variant="contained" 
            sx={{ 
              backgroundColor: '#4CAF50', 
              color: '#fff',
              '&:hover': { backgroundColor: '#388E3C' },
              padding: '10px 20px',
              fontSize: '1rem'
            }} 
            component={Link} 
            to="/publications-trimestrielles"
          >
            Publications Trimestrielles
          </Button>
        </Box>

        <Typography variant="body1" paragraph style={{ fontSize: '1.1rem' }}>
          Consultez le calendrier détaillé pour les années 2024-2025 : {' '}
          <Link 
            to="/calendarTable"
            style={{ 
              color: '#388E3C',
              fontWeight: 'bold',
              textDecoration: 'none',
              '&:hover': { textDecoration: 'underline' }
            }}
          >
            Télécharger le calendrier
          </Link>
        </Typography>
      </Container>
      <Footer />
    </div>
  );
}

export default PublicationSchedule;